import React from "react"
import styled from "styled-components"
import { Card, Col, Row } from "antd"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5rem;
  h1 {
    font-size: 46px;
    color: #172315;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
  }

  .circle {
    position: relative;
    width: 108px;
    height: 108px;
    border-radius: 54px;
    background-color: ${({ theme }) => theme.colors.secondary};

    & img {
      position: absolute;
      width: 50px;
      top: 24px;
      left: 30px;
      filter: brightness(0) invert(1);
    }
  }
  .circle-white {
    position: relative;
    width: 108px;
    height: 108px;
    border-radius: 54px;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid #172315;

    & img {
      position: absolute;
      width: 50px;
      top: 30px;
      left: 30px;
      filter: invert(9%) sepia(53%) saturate(415%) hue-rotate(65deg)
        brightness(98%) contrast(92%);
    }
  }
  .inner-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & h3 {
      margin-top: 1rem;
      font-size: 20px;
      color: #172315;
      font-weight: 600;
      text-align: center;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.lg)} {
    padding: 4rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding: 2rem;
  }
`

const HowItWorks = ({ data }) => {
  const {
    acf: { working_steps },
  } = data

  return (
    <StyledSection>
      <h1>How it Works</h1>
      <Row gutter={32}>
        {working_steps
          ? working_steps.map(step => (
              <Col xs={24} sm={24} md={12} lg={6} key={step.step_title}>
                <Card hoverable style={{ height: "250px" }}>
                  <div className="inner-card">
                    <div className="circle">
                      <img src={step.step_icon.url} alt="icon" />
                    </div>
                    <h3>{step.step_title}</h3>
                  </div>
                </Card>
              </Col>
            ))
          : null}
      </Row>
    </StyledSection>
  )
}

export default HowItWorks
